import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery";

export const prizeApi = createApi({
  reducerPath: "prizeApi",
  baseQuery: axiosBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api`,
  }),
  endpoints: (build) => ({
    getGameDetails: build.query({
      query({ query }) {
        return {
          url: "/admin/prizes/games",
          method: "GET",
          params: query
        };
      },
      providesTags: ["Games"],
    }),
    getWinners: build.query({
      query(params) {
        const queryParams = new URLSearchParams(params).toString();
        return {
          url: `/admin/winners?${queryParams}`,
          method: "GET",
        };
      },
      invalidatesTags: ["Prizes"],
    }),
    generateWinners: build.mutation({
      query(data) {
        return {
          url: "/admin/prizes/generate-winners",
          method: "POST",
          data: data,
        };
      },
    }),
    getUsersWithFilledConditions: build.query({
      query(params) {
        return {
          url: "/admin/prizes/potential-winners",
          method: "GET",
          params: params
        };
      },
      invalidatesTags: ["Prizes"],
    }),
    closeGame: build.mutation({
      query({ game_id }) {
        return {
          url: `/admin/prizes/games/end/${game_id}`,
          method: "PATCH",
        };
      },
      invalidatesTags: ['Games']
    }),
    getPotentialWinners: build.query({
      query(params) {
        // console.log({ params })
        // const queryParams = new URLSearchParams(params).toString();
        return {
          url: `/admin/prizes/potential-winners`,
          method: "GET",
          params: params
        }
      }
    })
  }),
});

export const {
  useGetGameDetailsQuery,
  useGetWinnersQuery,
  useGenerateWinnersMutation,
  useGetUsersWithFilledConditionsQuery,
  useLazyGetUsersWithFilledConditionsQuery,
  useCloseGameMutation,
  useLazyGetPotentialWinnersQuery
} = prizeApi;
